import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import genericPage from '../../assets/images/genericPage.png';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { VdsButton } from '../../vds';
import { StyledTitle } from '../../components/StyledTitle';
import { StyledDescription } from '../../components/StyledDescription';

export const LoginPage: React.FC = () => {

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={5} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={genericPage} width="450" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                sx={{
                    background: "#fff"
                }}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ACCEDI!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        Logout effettuato con successo. Accedi con l’account corretto, ovvero quello con l’e-mail dove hai ricevuto la promozione esclusiva.
                        <br />
                        <br />
                        Non riesci ad autenticarti contatta <a target="_blank" style={{ textDecoration: 'none' }} href="https://mysupport.teamsystem.com" rel='noreferrer'>My Support</a>
                        <br />
                        <br />
                    </StyledDescription>
                    <Box sx={{ padding: '0px 32px' }}>
                        <VdsButton variant="contained" color="primary" onClick={() => {
                            const urlParams = new URLSearchParams(window.location.search);
                            const token = urlParams.get("token");
                            window.location.href = window.location.origin + "?token=" + token;
                        }}>
                            Accedi
                        </VdsButton>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
